module.exports = __webpack_public_path__ + "images/rbk-54c226.svg";